import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createAction } from '@reduxjs/toolkit';
import { urlManager } from 'services/api/config';
import { authRepository } from 'services/api/network';
import { logout } from 'services/store/auth/actions';

export enum TagType {
  PROJECTS = 'PROJECTS',
  STUDIO_SONGS = 'STUDIO SONGS',
  PAYOUTS = 'PAYOUTS',
  YOUTUBE_CHANNEL = 'YOUTUBE CHANNEL',
  RELEASES_STATS = 'RELEASES STATS',
}

export const redirectToLoginPage = createAction('redirectToLoginPage');

const baseQuery = fetchBaseQuery({
  baseUrl: urlManager.base,
  prepareHeaders: (headers) => {
    headers.set('Accept', `application/json`);

    const token = authRepository.getAccessToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const baseApi = createApi({
  reducerPath: 'baseApi',
  tagTypes: [
    TagType.PROJECTS,
    TagType.STUDIO_SONGS,
    TagType.PAYOUTS,
    TagType.YOUTUBE_CHANNEL,
    TagType.RELEASES_STATS,
  ],
  baseQuery: async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (result.error?.status !== 401) return result;

    if (authRepository.getRefreshToken()) {
      await authRepository.updateToken();
      return baseQuery(args, api, extraOptions);
    }

    api.dispatch(logout());
    api.dispatch(redirectToLoginPage());
    return result;
  },
  endpoints: () => ({}),
});

export default baseApi;
